import React from 'react';

const Button = ({ text, firstTag, secondTag }) => {
  return (
    <div className="flex justify-center">
      <button className={`w-full max-w-xs md:max-w-sm rounded-full px-4 py-2 sm:py-3 md:py-4 font-semibold border 
                          ${text ? 'bg-blue-700 text-black text-sm md:text-base lg:text-lg' : 'text-gray-400 text-sm md:text-lg'}`}>
        {text ? firstTag : secondTag}
      </button>
    </div>
  );
};

export default Button;